import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LmsNewContentComponent } from './lms-new-content/lms-new-content.component';
import { LmsNewContentEditiorComponent } from './lms-new-content-editior/lms-new-content-editior.component';
import { LmsNewLayoutComponent } from './lms-new-layout/lms-new-layout.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule, Routes } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ArchwizardModule } from 'angular-archwizard';
import { FormsRoutingModule } from 'app/forms/forms-routing.module';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { TagInputModule } from 'ngx-chips';
import { CustomFormsModule } from 'ngx-custom-validators';
import { QuillModule } from 'ngx-quill';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UiSwitchModule } from 'ngx-ui-switch';
import { PipeModule } from 'app/shared/pipes/pipe.module';

const routes: Routes = [
  { path: 'lmss-new', component: LmsNewLayoutComponent },
  { path: 'content-new', component: LmsNewContentComponent },
  { path: 'edit-content', component: LmsNewContentEditiorComponent },
  { path: 'edit-video', component: LmsNewContentEditiorComponent },

];
@NgModule({
  declarations: [
    LmsNewContentComponent,
    LmsNewContentEditiorComponent,
    LmsNewLayoutComponent
  ],
  imports: [
    CommonModule,
    FormsRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    ArchwizardModule,
    CustomFormsModule,
    MatchHeightModule,
    UiSwitchModule,
    QuillModule.forRoot(),
    NgSelectModule,
    TagInputModule,
    MatMenuModule,
    DragDropModule,
    PipeModule,
    RouterModule.forChild(routes),
    // NgCircleProgressModule.forRoot({
    //   // set defaults here
    //   radius: 100,
    //   outerStrokeWidth: 16,
    //   innerStrokeWidth: 8,
    //   outerStrokeColor: "#78C000",
    //   innerStrokeColor: "#C7E596",
    //   animationDuration: 300,
    // }),
    NgxDatatableModule,
    NgxSpinnerModule
  ]
})
export class LmsLayoutNewModule { }
